export default __webpack_public_path__ + "static/media/logoRecruit.62e238e3.png";